import React from 'react'
import Layout from '../../components/Layout'
import LoginForm from '../../components/Form/LoginFrom'
import { useTranslation } from 'react-i18next'
const Login: React.FC = () => {
    const { t } = useTranslation()
    return (
        <>
            <Layout
                pageTitle={t('auth.login.title')}
                pageDescription={t('auth.login.description')}
            >
                <LoginForm />
            </Layout>
        </>
    )
}

export default Login
